<script lang="ts">
	interface Props {
		tag: string;
		headline: string;
	}

	const { tag, headline } = $$restProps as Props;
</script>

<section class="text-ltprimary mx-4 mb-0 pb-6 md:mx-16 md:pb-24 xl:mx-32">
	<div class="flex items-center gap-4">
		<span class="bg-ltprimary-200 h-px w-8"></span>
		<span class="text-ltprimary-200 uppercase">{tag}</span>
	</div>
	<div class="mt-16 grid grid-cols-1 gap-2 md:gap-8 xl:grid-cols-2 xl:gap-32">
		<div class="grid grid-cols-6 gap-4">
			<h1
				class="text-ltprimary col-span-full p-0 text-center font-light uppercase tracking-wider md:col-span-5 md:text-left"
			>
				{headline}
			</h1>
		</div>
		<div class="text-ltsecondary max-w-3xl">
			<slot />
		</div>
	</div>
</section>
